<template><!-- 削除モーダル -->
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
        <CRow>
        <CCol class="scr">
          <table class="table">
            <thead>
              <a style="font-size: 20px"><strong>削除内容確認</strong></a>
              <CCardText><strong>以下の内容を削除してよろしいですか？</strong></CCardText>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a><strong>取引先企業名</strong></a><br>
                  {{ val.company_name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>取引先担当者名</strong></a><br>
                  {{ val.staff_name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>電話番号</strong></a><br>
                  {{ val.telephone }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>住所</strong></a><br>
                  {{ val.address }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>E-Mail</strong></a><br>
                  {{ val.email }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>支払いサイト</strong></a><br>
                  {{ val.usance }}(日)
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>備考</strong></a><br>
                  {{ val.remarks }}
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
        </CRow>
        <CRow>
          <CCol sm="10">
            <button @click="$emit('close')" class="btn btn-secondary btn-sm">キャンセル</button>
          </CCol>
          <CCol>
            <save-button
              :text="'削除'"
              :loading="loading"
              @click="$emit('delete')"
              class="btn btn-danger"
            />
          </CCol>
        </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
export default {
  components: { SaveButton },
  name: 'ClientDeleteModal',
  data () {
    return {
    }
  },
  props: {
    val: Object,
    loading: Boolean,
  }
}
</script>

<style scoped>
  .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(80, 80, 80, 0.5);
      display: table;
      transition: opacity .3s ease;
    }
    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }
    .modal-container {
      width: 40%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }
    .scr{
      overflow: auto;
    }
</style>
